import { amountToDisplayValue, Color, DateTimeFormat, Text } from '@billy/design-system'
import { Tag } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../../utils/getCurrentLocale'
import { getLocalDateFromDateString } from '../../../utils/getLocalDateFromDateString'
import { TruncatedTextCell } from '../elements/TruncatedTextCell'
import type { LedgerEntry } from '../types/LedgerEntry'

export const formatAmount = (value: number | null): string => {
  if (value === null) {
    return ''
  }
  return amountToDisplayValue(value)
}

export const dateCell = (entry: LedgerEntry, isBold = false): ReactElement => (
  <Text weight={isBold ? 'bold' : undefined}>
    {DateTimeFormat.getFormattedDate(getLocalDateFromDateString(entry.date), getCurrentLocale())}
  </Text>
)

export const journalCell = (entry: LedgerEntry): ReactElement => (
  <Tag
    color={entry.isOpeningBalance ? 'blackAndWhite' : 'neutral'}
    label={entry.journal}
    size="xsmall"
    truncate
    type="subtle"
  />
)

export const amountCell = (value: number | null, isBold = false): ReactElement => (
  <TruncatedTextCell value={formatAmount(value)} weight={isBold ? 'bold' : undefined} />
)

export const balanceCell = (entry: LedgerEntry, isBold = false): ReactElement => (
  <TruncatedTextCell
    color={entry.balance < 0 ? Color.Red700 : undefined}
    value={formatAmount(entry.balance)}
    weight={isBold ? 'bold' : undefined}
  />
)
